import React from "react";

import {
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

import {
  getCustomFieldsTable,
  parseCustomFieldValue,
} from "../../../../components/common/CustomFields";
import {
  getFilePublicURL,
  getKeyFilename,
  getPhotoUrl,
} from "../../../../utils/fileUtils";
import {
  CarrierType,
  CustomFieldsDisplay,
  Unit,
} from "../../../../utils/constants";
import { getPPU, getUnitName } from "../../../../utils/loadTypeUtils";
import { trimDecimal } from "../../../../utils/utils";
import { calcTotalQuantity } from "../InboundUtils";

const getDisplayValue = (value) => {
  if (value == null) return "—";
  const str = String(value).trim();
  return str ? str : "—";
};

const formatCityStateZip = ({ city, state, zipCode }) => {
  const cityState =
    city && state ? `${city}, ${state}` : city ? city : state ? state : "";
  return [cityState, zipCode].filter(Boolean).join(" ").trim();
};

const getReceivedAtYard = (record) => {
  return record?.reloadYard || window.appUser?.reloadYard || null;
};

export const HeaderBlock = () => {
  const logoImage = window.appUser?.reloadYard?.logoImage;
  const logoURL = logoImage ? getPhotoUrl(logoImage.key, 128) : null;

  return (
    <div style={{ width: "100%" }}>
      {logoURL && (
        <div style={{ textAlign: "center" }}>
          <img
            alt="Yard Logo"
            src={logoURL}
            style={{
              margin: "0 auto",
              width: "auto",
              maxWidth: "90%",
              height: "auto",
              minHeight: "5em",
              maxHeight: "5em",
            }}
          />
        </div>
      )}
      <div>
        <Divider />
      </div>
      <div style={{ textAlign: "center" }}>
        <h2>
          <strong> INBOUND MANIFEST </strong>
        </h2>
      </div>
    </div>
  );
};

export const ReceivedAtBlock = ({ record }) => {
  const yard = getReceivedAtYard(record);
  const yardName = yard?.name;
  const yardStreet = yard?.street || yard?.address?.street;
  const yardCity = yard?.city || yard?.address?.city;
  const yardState = yard?.state || yard?.address?.state;
  const yardZipCode = yard?.zipCode || yard?.address?.zipCode;

  const accountName =
    record?.account?.displayName ||
    record?.account?.businessName ||
    record?.accountName ||
    record?.account?.name;
  const accountStreet = record?.account?.address?.street;
  const accountCity = record?.account?.address?.city;
  const accountState = record?.account?.address?.state;
  const accountZipCode = record?.account?.address?.zipCode;

  return (
    <div style={{ width: "100%" }}>
      <Divider />
      <h3>
        <strong> RECEIVED AT </strong>
      </h3>
      <Table key="receivedAt" style={{ width: "100%" }}>
        <TableHead>
          <TableRow>
            <TableCell style={{ textAlign: "left", width: "50%", padding: 3 }}>
              Received Location
            </TableCell>
            <TableCell style={{ textAlign: "left", width: "50%", padding: 3 }}>
              On Behalf Of
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "left", padding: 3 }}>
              <div style={{ fontWeight: 600 }}>{getDisplayValue(yardName)}</div>
              <div>{getDisplayValue(yardStreet)}</div>
              <div>
                {getDisplayValue(
                  formatCityStateZip({
                    city: yardCity,
                    state: yardState,
                    zipCode: yardZipCode,
                  }),
                )}
              </div>
            </TableCell>
            <TableCell style={{ textAlign: "left", padding: 3 }}>
              <div style={{ fontWeight: 600 }}>
                {getDisplayValue(accountName)}
              </div>
              {(accountStreet ||
                accountCity ||
                accountState ||
                accountZipCode) && (
                <>
                  <div>{getDisplayValue(accountStreet)}</div>
                  <div>
                    {getDisplayValue(
                      formatCityStateZip({
                        city: accountCity,
                        state: accountState,
                        zipCode: accountZipCode,
                      }),
                    )}
                  </div>
                </>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export const InfoBlock = ({ record }) => {
  const inboundCustomFields = (
    record?.account?.inboundCustomFields || []
  ).filter((field) => field.display.includes(CustomFieldsDisplay.POD));

  return (
    <div>
      <Table key="InfoBlock" style={{ width: "100%" }}>
        <TableHead>
          <TableRow>
            <TableCell
              style={{ textAlign: "center", width: "33%", padding: "3px" }}
            >
              Shipment Date
            </TableCell>
            <TableCell
              style={{ textAlign: "center", width: "33%", padding: "3px" }}
            >
              PO Number
            </TableCell>
            <TableCell
              style={{ textAlign: "center", width: "33%", padding: "3px" }}
            >
              {record.carrierType === CarrierType.RAIL
                ? "Railcar Number"
                : "Trailer Number"}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "center", padding: "3px" }}>
              {new Date(record.placedDateTime).toLocaleDateString()}
            </TableCell>
            <TableCell style={{ textAlign: "center", padding: "3px" }}>
              {record.poNumber}
            </TableCell>
            <TableCell style={{ textAlign: "center", padding: "3px" }}>
              {record.railCarNumber}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table key="timeBlock" style={{ width: "100%" }}>
        <TableHead>
          <TableRow>
            <TableCell
              style={{ textAlign: "center", width: "33%", padding: "3px" }}
            >
              Arrived
            </TableCell>
            <TableCell
              style={{ textAlign: "center", width: "33%", padding: "3px" }}
            >
              Released
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "center", padding: "3px" }}>
              {record.placedDateTime
                ? new Date(record.placedDateTime).toLocaleDateString()
                : "N/A"}
            </TableCell>
            <TableCell style={{ textAlign: "center", padding: "3px" }}>
              {record.releaseDateTime
                ? new Date(record.releaseDateTime).toLocaleString()
                : "N/A"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      {getCustomFieldsTable(inboundCustomFields, record.customFields)}
    </div>
  );
};

const LineItemsBlock = ({ record, podInventories }) => {
  const inventoryCustomFields = (
    record?.account?.inventoryCustomFields || []
  ).filter((field) => field.display.includes(CustomFieldsDisplay.POD));
  const showProductCodeColumn = record.inventories.items.some(
    (lineItem) => lineItem.productCode && lineItem.productCode.trim(),
  );
  const showPCSColumn = podInventories.some((lineItem) => lineItem.pcs != null);
  const pcsColumnName = record.totalUOM === Unit.UNIT ? "PPU" : "Pieces";

  return (
    <div style={{ width: "100%" }}>
      <Divider />
      <h3>
        <strong> INVENTORY RECEIVED </strong>
      </h3>
      <Table key="inboundInventory" style={{ width: "100%" }}>
        <TableHead>
          <TableRow>
            {showProductCodeColumn && (
              <TableCell
                style={{ textAlign: "left", minWidth: "25%", padding: "3px" }}
              >
                Product Code
              </TableCell>
            )}
            <TableCell
              style={{ textAlign: "left", minWidth: "25%", padding: "3px" }}
            >
              Product Name
            </TableCell>
            <TableCell
              style={{ textAlign: "right", minWidth: "25%", padding: "3px" }}
            >
              {getUnitName(record.totalUOM)}
            </TableCell>
            {showPCSColumn && (
              <TableCell
                style={{ textAlign: "right", width: "25%", padding: "3px" }}
              >
                {pcsColumnName}
              </TableCell>
            )}
            {inventoryCustomFields.map((field, index) => (
              <TableCell
                key={"cf_" + index}
                style={{ textAlign: "center", padding: "3px" }}
              >
                {field.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {podInventories.map((lineItem) => (
            <TableRow key={lineItem.id}>
              {showProductCodeColumn && (
                <TableCell style={{ textAlign: "left", padding: "3px" }}>
                  {lineItem.productCode}
                </TableCell>
              )}
              <TableCell style={{ textAlign: "left", padding: "3px" }}>
                {lineItem.productName}
              </TableCell>
              <TableCell style={{ textAlign: "right", padding: "3px" }}>
                {lineItem.quantityReceived}
              </TableCell>
              {showPCSColumn && (
                <TableCell
                  style={{ textAlign: "right", padding: "3px", width: "10%" }}
                >
                  {lineItem.pcs != null ? lineItem.pcs : "--"}
                </TableCell>
              )}
              {inventoryCustomFields.map((field, index) => {
                const customFieldValue = lineItem.customFields?.find((cf) =>
                  cf.startsWith(field.name),
                );

                return (
                  <TableCell
                    key={"inv_cf_" + index}
                    style={{ textAlign: "center", padding: "3px" }}
                  >
                    {parseCustomFieldValue(customFieldValue)}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

const TotalsBlock = ({ record, podInventories }) => {
  const totalQuantity = calcTotalQuantity(record);

  // PCS Totals and Flags
  let totalPCS = 0;
  let allMissingPCS = true;
  let somePCSNull = false;

  podInventories.forEach((lineItem) => {
    const linePpu = lineItem.pcs;
    if (linePpu == null || linePpu === "") {
      somePCSNull = true;
    } else {
      allMissingPCS = false;
      if (record.totalUOM === Unit.UNIT) {
        totalPCS += linePpu * lineItem.quantityReceived;
      } else {
        totalPCS += linePpu;
      }
    }
  });

  return (
    <div style={{ width: "100%" }}>
      <Divider />
      <Table id="inboundTotals" key="inboundTotals" style={{ width: "100%" }}>
        <TableBody>
          <TableRow key="totalUOM">
            <TableCell
              style={{ textAlign: "right", minWidth: "66%", padding: "3px" }}
            >
              Total {getUnitName(record.totalUOM)}
            </TableCell>
            <TableCell
              style={{ textAlign: "right", minWidth: "33%", padding: "3px" }}
            >
              {totalQuantity}
            </TableCell>
          </TableRow>
          {!allMissingPCS && (
            <TableRow key="totalPCS">
              <TableCell
                style={{ textAlign: "right", minWidth: "66%", padding: "3px" }}
              >
                Total Pieces
              </TableCell>
              <TableCell
                style={{ textAlign: "right", minWidth: "33%", padding: "3px" }}
              >
                {somePCSNull ? "N/A" : trimDecimal(totalPCS).toLocaleString()}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export const AttachmentsBlock = ({ record }) => {
  const attachments =
    record.attachments?.length > 0 ? record.attachments : null;
  const receipt = record.receiptFile;

  if (!attachments && !receipt) return <></>;
  return (
    <div style={{ width: "100%" }}>
      <div>
        <Divider />
      </div>
      <Table key="inboundDocs" style={{ width: "100%" }}>
        <TableBody>
          {attachments?.map((row, index) => (
            <TableRow key={"att_" + index}>
              <TableCell style={{ textAlign: "left" }}>
                {row.key && (
                  <a
                    href={getFilePublicURL(row.key)}
                    style={{
                      margin: "0 auto",
                      width: "auto",
                      maxWidth: "90%",
                    }}
                  >
                    {getKeyFilename(row.key)}
                  </a>
                )}
              </TableCell>
            </TableRow>
          ))}
          {receipt && (
            <TableRow key="receipt">
              <TableCell style={{ textAlign: "left" }}>
                {receipt.key && (
                  <a
                    href={getFilePublicURL(receipt.key)}
                    style={{
                      margin: "0 auto",
                      width: "auto",
                      maxWidth: "90%",
                    }}
                  >
                    {getKeyFilename(receipt.key)}
                  </a>
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export const PhotosBlock = ({ record }) => {
  const rowSize = 3;
  const photosRows = [];
  const photos = record.photos?.items ?? [];
  for (var i = 0; i < photos.length; i += rowSize) {
    photosRows.push(photos.slice(i, i + rowSize));
  }

  return (
    <div style={{ width: "100%" }}>
      <div>
        <Divider />
      </div>
      <Table id="inboundPhotos" key="inboundPhotos" style={{ width: "100%" }}>
        <TableBody>
          {photosRows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell style={{ textAlign: "center" }}>
                {row[0]?.key && (
                  <img
                    alt="Inbound Load"
                    src={getPhotoUrl(row[0].key, 256)}
                    style={{
                      margin: "0 auto",
                      width: "auto",
                      maxWidth: "90%",
                      height: "auto",
                      borderRadius: 5,
                    }}
                  />
                )}
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                {row[1]?.key && (
                  <img
                    alt="Inbound Load"
                    src={getPhotoUrl(row[1].key, 256)}
                    style={{
                      margin: "0 auto",
                      width: "auto",
                      maxWidth: "90%",
                      height: "auto",
                      borderRadius: 5,
                    }}
                  />
                )}
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                {row[2]?.key && (
                  <img
                    alt="Inbound Load"
                    src={getPhotoUrl(row[2].key, 256)}
                    style={{
                      margin: "0 auto",
                      width: "auto",
                      maxWidth: "90%",
                      height: "auto",
                      borderRadius: 5,
                    }}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export const SealsBlock = ({ record }) => {
  const showSeals =
    record?.account?.trackInboundSeals || record.seals?.items?.length > 0;
  if (!showSeals) return null;

  const sealBarCodes = record.seals?.items?.map((seal) => seal.barcode) || [];

  const renderSeals = () => {
    if (sealBarCodes.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={9} style={{ textAlign: "left" }}>
            No seals were entered
          </TableCell>
        </TableRow>
      );
    }

    const rows = [];
    for (let i = 0; i < sealBarCodes.length; i += 9) {
      const cells = [];
      for (let j = i; j < i + 9 && j < sealBarCodes.length; j++) {
        cells.push(
          <TableCell key={j} style={{ textAlign: "left", padding: "3px" }}>
            {sealBarCodes[j]}
          </TableCell>,
        );
      }
      rows.push(<TableRow key={i}>{cells}</TableRow>);
    }
    return rows;
  };

  return (
    <div style={{ width: "100%" }}>
      <Divider />
      <h3>
        <strong>SEALS</strong>
      </h3>
      <Table id="inboundSeals" style={{ width: "100%" }}>
        <TableBody>{renderSeals()}</TableBody>
      </Table>
    </div>
  );
};

export const NotesBlock = ({ record }) => {
  const filteredNotes = record.notes?.filter((note) => note.public);
  if (!filteredNotes || filteredNotes?.length === 0) return null;

  return (
    <div style={{ width: "100%" }}>
      <Divider />
      <h3>
        <strong> NOTES </strong>
      </h3>
      <Table key="inboundInventory" style={{ width: "100%" }}>
        <TableHead>
          <TableRow>
            <TableCell
              style={{ textAlign: "left", minWidth: "60%", padding: "3px" }}
            >
              Note
            </TableCell>
            <TableCell
              style={{ textAlign: "left", minWidth: "20%", padding: "3px" }}
            >
              By
            </TableCell>
            <TableCell
              style={{ textAlign: "right", minWidth: "20%", padding: "3px" }}
            >
              Date
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredNotes.map((lineItem) => (
            <TableRow key={lineItem.id}>
              <TableCell style={{ textAlign: "left", padding: "3px" }}>
                {lineItem.text}
              </TableCell>
              <TableCell style={{ textAlign: "left", padding: "3px" }}>
                {lineItem.by}
              </TableCell>
              <TableCell style={{ textAlign: "right", padding: "3px" }}>
                {new Date(lineItem.date).toLocaleDateString()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export const InboundPODBody = ({
  record,
  enclosePhotos,
  encloseAttachments,
}) => {
  const podInventories = record.inventories.items.map((lineItem) => {
    return {
      ...lineItem,
      pcs: getPPU(lineItem),
    };
  });

  return (
    <Paper elevation={0} style={{ maxWidth: "900px", padding: "10px" }}>
      <HeaderBlock />
      <InfoBlock record={record} />
      <ReceivedAtBlock record={record} />
      <LineItemsBlock record={record} podInventories={podInventories} />
      <TotalsBlock record={record} podInventories={podInventories} />
      <SealsBlock record={record} />
      <NotesBlock record={record} />
      {encloseAttachments && <AttachmentsBlock record={record} />}
      {enclosePhotos && <PhotosBlock record={record} />}
    </Paper>
  );
};
